import React, { useEffect, useRef, useState } from "react";
import "./DetailInfo.scss";
import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  notification,
} from "antd";
import {
  columnsTableAnalysisList,
  // columnsTablePatient,
} from "./DetailInfo.config";
import { ListIconSVG, MicroscopeIconSVG, SaveIconSVG } from "assets";
import MySteps from "./StepAnalysis/StepAnalysis";
import { analysisService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import Icon from "assets/icons";
import {
  ColumnPopoverDisplay,
  InputFields,
  ModalCustom,
  StepInfo,
} from "components/common";
import {
  setCallApi,
  setDataPay,
  setIdKQXN,
  setIdSecond,
  setTGLayMau,
  setValueInput,
} from "redux/reducer/reduxCommon";
import {
  Cancel,
  Completed,
  NextPatient,
  Pause,
  Save,
  SaveAndPrint,
} from "./config";
import { FORMAT_TIME, TEN_PHONG, tabKeys } from "types/enums";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import { fieldsPatient } from "./PatientAnalysis/PatientAnalysis.config";
import { ColumnProps } from "types/models";
import ModalResults from "./ModalResults/ModalResults";
import TableSpecimens from "./TableSpecimens/TableSpecimens";
import {
  disableBtn,
  dispatchCurrentRoom,
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import dayjs from "dayjs";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";
import Notification from "components/common/notification/notification";
import ResultsAnalysis from "./ResultsAnalysis/ResultsAnalysis";
import ModalPrint from "./ModalPrint/ModalPrint";
import { catalogService } from "api";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import AlertModal from "components/common/AlertModal/AlertModal";

type infoDetails = {
  chiTietLoaiKhamChuaBenh: any;
  chiTietTrangThaiBaoHiem: any;
  chiTietTrangThaiThanhToan: any;
  diaChi: string;
  gioiTinh: number;
  hoVaTen: string;
  id: number;
  idKhuKhamChuaBenh: any;
  idLoaiKhamChuaBenh: number;
  idTrangThaiBaoHiem: number;
  idTrangThaiThanhToan: number;
  maBenhNhan: any;
  maKhamBenh: any;
  ngaySinh: string;
  soTheBaoHiemYTe: string;
  tenNhanVienThanhToan: any;
  tenNhanVienTiepNhan: any;
  tienTranBaoHiem: number;
};

const DetailInfo: React.FC = () => {
  const idXetNghiem = useAppSelector((state) => state.reduxCommon.idXetNghiem);
  // const [idXN, setIdXN] = useState(idXetNghiem);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [dataList, setDataList] = useState([]);
  const [dataInfo, setDataInfo] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowResult, setIsShowResult] = useState(false);
  const [listMachine, setListMachine] = useState([]);
  const [listMethod, setListMethod] = useState([]);
  const [listMBP, setListMBP] = useState([]);
  const [form] = Form.useForm();
  const [trangThaiPhieu, setTrangThaiPhieu] = useState<any>();
  const [formData] = Form.useForm();
  const dispatch = useAppDispatch();
  const stepInfoRef = useRef<any>();
  const modalAlertRef = useRef<any>();

  // const [isShowModalEdit, setIsShowModalEdit] = useState(false);
  const activeTab = useAppSelector((state) => state.common.activeTab);
  const [selectedRowKeysList, setSelectedRowKeysList] = useState<React.Key[]>(
    []
  );
  const TGChiDinh = useAppSelector((state) => state.reduxCommon.thoiGian);
  const [listIdPrint, setListIdPrint] = useState([]);
  const [detailRecord, setDetailRecord] = useState(null);
  const [selectedRowsList, setSelectedRowsList] = useState([]);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [field, setField] = useState(fieldsPatient);
  const nguoiDuyetKQ = useAppSelector(
    (state) => state.reduxCommon.nguoiDuyetXN
  );
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const formatParams = () => {
    return {
      ...params,
    };
  };

  let savedTableOption = getTableOptions(
    "ANALYSIS_DETAIL_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsTableAnalysisList.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsTableAnalysisList;

  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show == true)
  );

  useEffect(() => {
    if (!idXetNghiem) {
      dispatch(setActiveKey(tabKeys.ANALYSIS.LIST_PATIENT_ANALYSIS));
    }
  }, [idXetNghiem]);

  const getDetailPatient = async () => {
    setLoading(true);
    try {
      const response = await analysisService
        .getDetailPatient(idXetNghiem)
        .then((res) => {
          const data = res.data;
          // console.log('data bn', data);
          form.setFieldsValue({
            ...data,
            thoiGianKham: data?.thoiGianKham
              ? moment(data.thoiGianKham).format(FORMAT_TIME.dateTime)
              : "",
            ngayTao: data?.ngayTao ? moment(data.ngayTao) : "",
            thoiGianChiDinh: TGChiDinh ? moment(TGChiDinh) : null,
            nvThucHien: data?.nvThucHien
              ? data?.nvThucHien
              : localStorage.getItem("fullName"),
            truongKhoaXetNghiem: data?.truongKhoaXetNghiem
              ? data?.truongKhoaXetNghiem
              : "Đậu Trung Hiếu",
          });
          setTrangThaiPhieu(res.data.trangThai);
          if (res.data.trangThai == 1) {
            handleUpdate();
          }
          const dataChiDinh = res.data.chiDinhXetNghiemDto.map((item) => ({
            ...item,
            id: item.id,
            maXetNghiem: item.maXetNghiem,
            idChiDinh: item.idChiDinh,
            idDichVu: item.idDichVu,
            idNhomDichVu: item.idNhomDichVu,
            idPhieuXetNghiem: item.idPhieuXetNghiem,
            maBenhPham: item.maBenhPham,
            tenDichVuXN: item.tenXetNghiem,
            thoiGianLayMauRequire: item.thoiGianLayMau,
            thoiGianLayMau: item.thoiGianLayMau
              ? moment(item.thoiGianLayMau).format(FORMAT_TIME.dateTime_3)
              : "",
            thoiGianTraKetQua: item.thoiGianTraKetQua,
            nhanVienLayMau: item.nvLayMau,
            tenNhomXetNghiem: item.tenNhomXetNghiem,
            mayXetNghiem: item.mayXetNghiem,
            // nguoiNhapKetQua: item.nguoiNhapKetQua,
            nguoiNhapKetQua: localStorage.getItem("fullName"),
            thoiGianDuyet: item.thoiGianDuyetKetQua
              ? moment(item.thoiGianDuyet).format(FORMAT_TIME.dateTime_3)
              : "",
            nguoiDuyetKetQua: "Ths. Đậu Trung Hiếu",
            thoiGianDuyetKetQua: item.thoiGianDuyetKetQua,
            phươngPhap: item.phuongPhapXetNghiem,
            ghiChu: item.ghiChu,
          }));
          const newData = dataChiDinh.map((item) => ({
            ...item,
            key: item.id,
          }));
          const idArray = newData.map((item) => item.id);
          if (!selectedRowsList.length) {
            setListIdPrint(idArray);
          }
          setDataInfo(data);
          dispatch(setIdSecond(res?.data?.id));
          dispatch(setIdPhieuKham(res?.data?.idPhieuKham));
          dispatchCurrentRoom(
            dispatch,
            res?.data.trangThai,
            TEN_PHONG.xet_nghiem
          );
          setDataList(newData);
          setLoading(false);
          // console.log('id second',res.data.id);
        });
    } catch (error) {
      setLoading(false);
      if (idXetNghiem) {
        Notification(
          "error",
          "Đã có lỗi xảy ra khi lấy dữ liệu phiếu xét nghiệm"
        );
      }
    }
    // let id;
    // if (idXetNghiem) {
    //   id = idXetNghiem;
    // } else {
    //   id = idXN;
    // }
  };

  useEffect(() => {
    if (!selectedRowKeysList.length) {
      setSelectedRowsList([]);
    }
  }, []);

  useEffect(() => {
    const idArray = dataList.map((item) => item.id);
    if (!selectedRowsList.length) {
      setListIdPrint(idArray);
    }
  }, [selectedRowsList, dataList, idXetNghiem]);

  useEffect(() => {
    getListBPbyId();
    getDetailPatient();
  }, [idXetNghiem, callApi]);

  useEffect(() => {
    if (activeTab == tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS) {
      dispatch(
        setButtonsHeader([
          SaveAndPrint(handleSaveAndPrint),
          Completed(saveStatusTicket, trangThaiPhieu),
          // Save(handleValidateFields),
          // NextPatient(handleNextPatient),
          Cancel(handleCancelAction, trangThaiPhieu),
          Pause(handlePause, trangThaiPhieu),
        ])
      );
    }
  }, [activeTab]);

  const handleSaveAndPrint = () => {
    setIsShowModalPrint(true);
  };

  const handleCompleted = async (trangThai) => {
    const nvThucHien = form.getFieldValue("nvThucHien");
    try {
      const response = await analysisService
        .updateStatusPCDXN(idXetNghiem, 3, nvThucHien)
        .then((res) => {
          Notification("success", "Cập nhật trạng thái thành công");
        });
      // setTrangThaiPhieu(3);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
    }
    getDetailPatient();
    dispatch(setCallApi());
  };

  const handleNextPatient = () => {};

  const handleCancelAction = async (trangThai) => {
    const nvThucHien = form.getFieldValue("nvThucHien");
    const truongKhoaXetNghiem = form.getFieldValue("truongKhoaXetNghiem");
    setLoading(true);
    try {
      const response = await analysisService
        .updateStatusPCDXN(idXetNghiem, 6, nvThucHien, truongKhoaXetNghiem)
        .then((res) => {
          Notification("success", "Cập nhật trạng thái thành công");
          getDetailPatient();
          setLoading(false);
        });
      // setTrangThaiPhieu(6);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
      setLoading(false);
    }
    dispatch(setCallApi());
  };

  const handlePause = async () => {
    const nvThucHien = form.getFieldValue("nvThucHien");
    const truongKhoaXetNghiem = form.getFieldValue("truongKhoaXetNghiem");
    setLoading(true);
    try {
      const response = await analysisService
        .updateStatusPCDXN(idXetNghiem, 1, nvThucHien, truongKhoaXetNghiem)
        .then((res) => {
          Notification("success", "Cập nhật trạng thái thành công");
          // setTrangThaiPhieu(1);
          getDetailPatient();
          setLoading(false);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
      setLoading(false);
    }
    dispatch(setCallApi());
  };

  const handleUpdate = async () => {
    const nvThucHien = form.getFieldValue("nvThucHien");
    const truongKhoaXetNghiem = form.getFieldValue("truongKhoaXetNghiem");
    try {
      const response = await analysisService
        .updateStatusPCDXN(idXetNghiem, 2, nvThucHien, truongKhoaXetNghiem)
        .then((res) => {
          Notification("success", "Cập nhật trạng thái thành công");
          setTrangThaiPhieu(2);
          getDetailPatient();
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
    }
    dispatch(setCallApi());
  };

  const saveStatusTicket = async () => {
    const ngayTao = form.getFieldValue("ngayTao");

    // const res = disableBtn(ngayTao);
    // if (res) {
    //   modalAlertRef.current.openModal();
    //   setLoading(false);
    //   return;
    // }
    const nvThucHien = form.getFieldValue("nvThucHien");
    const truongKhoaXetNghiem = form.getFieldValue("truongKhoaXetNghiem");
    let nguoiDuyet;
    if (!nguoiDuyetKQ) {
      nguoiDuyet = "Ths Đậu Trung Hiếu";
    } else {
      nguoiDuyet = nguoiDuyetKQ;
    }
    setLoading(true);
    try {
      const response = await analysisService
        .saveStatus(idXetNghiem, 3, nvThucHien, nguoiDuyet, truongKhoaXetNghiem)
        .then((res) => {
          Notification("success", "Cập nhật trạng thái thành công");
          // console.log("res cập nhật", res);
          updateDataStatus(res.data);
          // setTrangThaiPhieu(1);
          getDetailPatient();
          setLoading(false);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
      setLoading(false);
    }
  };

  const updateDataStatus = async (data) => {
    const nvThucHien = form.getFieldValue("nvThucHien");
    const truongKhoaXetNghiem = form.getFieldValue("truongKhoaXetNghiem");
    const ghiChu = form.getFieldValue("ghiChu");
    const body = {
      id: data.id,
      idPhieuChiDinh: data.idPhieuChiDinh,
      idPhieuKhamNgoaiTru: data.idPhieuKhamNgoaiTru,
      idPhieuKham: data.idPhieuKham,
      ngayTao: data.ngayTao,
      thoiGianChiDinh: data.thoiGianChiDinh,
      thoiGianHoanThanh: data.thoiGianHoanThanh,
      thoiGianKham: data.thoiGianKham,
      nvThucHien: nvThucHien,
      truongKhoaXetNghiem: truongKhoaXetNghiem,
      trangThai: data.trangThai,
      trangThaiThanhToan: data.trangThaiThanhToan,
      ghiChu: ghiChu,
      bacSyChiDinh: data.bacSyChiDinh,
    };
    try {
      const response = await analysisService
        .updateStatus(data.id, body)
        .then((res) => {
          // console.log('response', res);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật trạng thái");
    }
  };

  // console.log('id xet nghiem', idXetNghiem);

  const handleOnSave = async (record) => {
    // console.log("data save", listMBP);
    if (listMBP.length) {
      const dataPut = dataList.map((item) => ({
        id: item.id,
        maBenhPham: item.maBenhPham ? item.maBenhPham : listMBP[0].label,
        nvLayMau: item.nhanVienLayMau
          ? item.nhanVienLayMau
          : listMBP[0].nhanVienLayMau,
        mayXetNghiem: item.mayXetNghiem,
        phuongPhapXetNghiem: item.phươngPhap,
        thoiGianLayMau: item.thoiGianLayMau
          ? dayjs(item.thoiGianLayMau, "HH:mm:ss DD/MM/YYYY").format(
              FORMAT_TIME.timeDetail
            )
          : listMBP[0].thoiGianLayMau,
        // thoiGianTraKetQua: item.thoiGianTraKetQua ? item.thoiGianTraKetQua : add2Hours(listMBP[0].thoiGianLayMau),
        thoiGianTraKetQua: item.thoiGianTraKetQua
          ? item.thoiGianTraKetQua
          : dayjs(),
        thoiGianDuyetKetQua: item.thoiGianDuyetKetQua,
        nguoiNhapKetQua: item.nguoiNhapKetQua,
        nguoiDuyetKetQua: item.nguoiDuyetKetQua,
        ghiChu: item.ghiChu ? item.ghiChu : listMBP[0].ghiChu,
      }));
      // console.log("data save", dataPut);
      setLoading(true);
      try {
        const response = await analysisService
          .saveAnalysisResult(dataPut)
          .then((res) => {
            Notification("success", "Lưu thành công");
            setLoading(false);
            getDetailPatient();
          });
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã có lỗi xảy ra khi lưu");
      }
    } else {
      Notification("warning", "Vui lòng thêm mã bệnh phẩm");
    }
  };

  const showModal = async (record) => {
    // console.log("🚀 ~ file: DetailInfo.tsx:304 ~ showModal ~ record:", record)
    // dispatch(setIdSecond(record.id));
    // console.log('dsadsadsadsadas',record);
    setDetailRecord(record);
    dispatch(setValueInput(record.nguoiNhapKetQua));
    dispatch(setIdKQXN(record.id));
    setIsShowModal(true);
  };

  const showResult = async (record) => {
    // dispatch(setIdSecond(record.id));2
    dispatch(setValueInput(record.nguoiNhapKetQua));
    setIsShowResult(true);
  };

  const handleOnSubmit = async (record) => {
    // console.log("record", record);
    const newData = {
      id: record.id,
      nguoiDuyetKetQua: record.nguoiDuyetKetQua,
      thoiGianTraKetQua: record.thoiGianTraKetQua,
      thoiGianDuyetKetQua: record.thoiGianDuyetKetQua,
    };
    setLoadingTable(true);
    try {
      const response = await analysisService
        .submitAnalysisResult(newData)
        .then((res) => {
          Notification("success", "Duyệt thành công");
          getDetailPatient();
          setLoadingTable(false);
        });
    } catch (error) {
      setLoadingTable(false);
      Notification("error", "Đã có lỗi xảy ra khi duyệt");
    }
  };

  useEffect(() => {
    columnsTableAnalysisList.map((item) => {
      if (item.key == "action") {
        item.render = (value, record) => (
          <div className="group-button-action">
            <Space size={16}>
              {/* <Button
                icon={<SaveIconSVG />}
                type="text"
                onClick={() => handleOnSave(record)}
              /> */}
              <Button
                icon={<MicroscopeIconSVG />}
                type="text"
                onClick={() => showModal(record)}
              />
              <div
                style={{
                  color: "#00B335",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => handleOnSubmit(record)}
              >
                Duyệt
              </div>
            </Space>
          </div>
        );
      }
    });
  }, [columnsTableAnalysisList]);

  const add2Hours = (time) => {
    var originalDate = new Date(time);
    originalDate.setHours(originalDate.getHours() + 2);
    var newDateTimeString = originalDate.toISOString();
    // console.log('time add ', newDateTimeString);
    return newDateTimeString;
  };

  const setValueRow = (value: any, name: string, record: any) => {
    setDataList((prevDataTable) => {
      return prevDataTable.map((prevItem) =>
        prevItem.id === record.id
          ? {
              ...prevItem,
              [name]: value.target.value,
            }
          : prevItem
      );
    });
  };

  columns.map((record) => {
    if (record.dataIndex == "stt") {
      record.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
    if (record.dataIndex == "mayXetNghiem") {
      record.render = (value, record, index) => (
        <Select
          style={{ width: "100%" }}
          options={listMachine}
          value={value}
          onChange={(e, option) => {
            setDataList((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.idNhomDichVu === record.idNhomDichVu
                  ? {
                      ...prevItem,
                      mayXetNghiem: option.label,
                    }
                  : prevItem
              );
            });
          }}
        ></Select>
      );
    }
    if (record.dataIndex == "phươngPhap") {
      record.render = (value, record, index) => (
        <Select
          style={{ width: "100%" }}
          options={listMethod}
          value={value}
          onChange={(e, option) => {
            setDataList((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.id === record.id
                  ? {
                      ...prevItem,
                      phươngPhap: option.label,
                    }
                  : prevItem
              );
            });
          }}
        ></Select>
      );
    }
    if (record.dataIndex == "ghiChu") {
      record.render = (value, record, index) => {
        return (
          <Input
            style={{ width: "100%" }}
            placeholder="Nhập"
            value={value}
            onChange={(e) => setValueRow(e, "ghiChu", record)}
          ></Input>
        );
      };
    }
    if (record.dataIndex == "nguoiNhapKetQua") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Input
          style={{ width: "100%" }}
          // placeholder="Nhập"
          value={value}
          onChange={(e) =>
            setDataList((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.id === record.id
                  ? {
                      ...prevItem,
                      nguoiNhapKetQua: e.target.value,
                    }
                  : prevItem
              );
            })
          }
        ></Input>
      );
    }

    if (record.dataIndex == "thoiGianTraKetQua") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <DatePicker
          value={value ? dayjs(value) : null}
          format={`${FORMAT_TIME.dateTime}`}
          showTime={true}
          onChange={(e) =>
            setDataList((prevDataTable) => {
              // console.log('dsadsdsadasdas', e);
              return prevDataTable.map(
                (prevItem) =>
                  // prevItem.id === record.id
                  //   ?
                  ({
                    ...prevItem,
                    thoiGianTraKetQua: e ? dayjs(e) : null,
                  })
                // : prevItem
              );
            })
          }
        ></DatePicker>
      );
    }

    if (record.dataIndex == "thoiGianDuyetKetQua") {
      record.render = (value, record, index) => (
        <DatePicker
          value={value ? dayjs(value) : null}
          format={`${FORMAT_TIME.dateTime}`}
          showTime={true}
          onChange={(e) =>
            setDataList((prevDataTable) => {
              return prevDataTable.map(
                (prevItem) =>
                  // prevItem.id === record.id
                  // ?
                  ({
                    ...prevItem,
                    thoiGianDuyetKetQua: e ? dayjs(e) : null,
                  })
                // : prevItem
              );
            })
          }
        ></DatePicker>
      );
    }

    if (record.dataIndex == "nguoiDuyetKetQua") {
      record.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Input
          style={{ width: "100%" }}
          // placeholder="Nhập"
          value={value}
          onChange={(e) =>
            setDataList((prevDataTable) => {
              return prevDataTable.map((prevItem) =>
                prevItem.id === record.id
                  ? {
                      ...prevItem,
                      nguoiDuyetKetQua: e.target.value,
                    }
                  : prevItem
              );
            })
          }
        ></Input>
      );
    }

    if (record.dataIndex == "maBenhPham") {
      record.render = (value, record, index) => {
        return (
          <Select
            style={{ width: "100%" }}
            options={listMBP}
            value={value}
            onChange={(e, option) => {
              // dispatch(setTGLayMau)
              // console.log('time ket qua', add2Hours(option.thoiGianLayMau));
              // const thoiGianKQ = add2Hours(option.thoiGianLayMau)
              setDataList((prevDataTable) => {
                return prevDataTable.map((prevItem) =>
                  prevItem.id === record.id
                    ? {
                        ...prevItem,
                        maBenhPham: option.label,
                        nhanVienLayMau: option.nhanVienLayMau,
                        thoiGianLayMau: moment(option.thoiGianLayMau).format(
                          FORMAT_TIME.dateTime_3
                        ),
                        ghiChu: option.ghiChu,
                        thoiGianTraKetQua: dayjs(),
                      }
                    : prevItem
                );
              });
            }}
          ></Select>
        );
      };
    }
  });

  const convertDateFormat = (inputDate) => {
    if (inputDate) {
      const parts = inputDate.split(" - ");
      const timePart = parts[0];
      const datePart = parts[1];
      const [hour, minute, second] = timePart.split(":");
      const [day, month, year] = datePart.split("/");
      const newDate = dayjs(
        `${year}-${month}-${day}T${hour}:${minute}:${second}`
      );
      const isoDateString = newDate.toISOString();
      return isoDateString;
    }
    return;
  };

  useEffect(() => {
    if (dataList) {
      // console.log('thoi gian lay mau',dataList);
      // let thoiGian = dayjs(dataList[0]?.thoiGianLayMau).format(
      //   FORMAT_TIME.dayFull
      // );
      let thoiGian = convertDateFormat(dataList[0]?.thoiGianLayMau);
      let thoiGianLayMau = dayjs(thoiGian).format(FORMAT_TIME.dayFull);
      // console.log('thoi gian lay mau',thoiGian);
      dispatch(setTGLayMau(thoiGianLayMau));
    }
  }, [dataList, callApi]);

  const handlePaginationChange = (page) => {
    setCurrentPage(page);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    onChange: handlePaginationChange,
  };

  useEffect(() => {
    getListMachine();
    getListMethod();
    getListBPbyId();
    getListLoaiKCB();
  }, [idXetNghiem, callApi]);

  const getListLoaiKCB = async () => {
    try {
      const res = await catalogService.getListLoaiKCB();
      fieldsPatient.find((e) => e.name == "loaiKCB").options = await res.map(
        (e) => {
          return { value: e.id, label: e.tenLoaiKCB };
        }
      );
      setField([...fieldsPatient]);
    } catch (error) {
      // Notification("error", "Đã có lỗi khi lấy danh sách loại khám chữa bệnh");
      // fields[8].options = [];
    }
  };

  const getListBPbyId = async () => {
    try {
      const response = await analysisService
        .getSpecimenById(idXetNghiem)
        .then((res) => {
          // console.log("res ma benh pham by id", res);
          const newData = res.data.map((item) => ({
            ...item,
            value: item.id.toString(),
            label: item.maBenhPham,
            nhanVienLayMau: item.nhanVienLayMau,
            thoiGianLayMau: item.thoiGianLayMau,
            ghiChu: item.ghiChu,
          }));
          setListMBP(newData);
        });
    } catch (error) {
      // Notification("error", "Đã có lỗi xảy ra khi lấy danh sách bệnh phẩm");
    }
  };

  const getListMachine = async () => {
    try {
      const response = await analysisService.getListMachine().then((res) => {
        // console.log("res danh sach may xet nghiem", res);
        const newData = res.data.map((item) => ({
          id: item.id,
          value: item.id,
          label: item.tenMayXetNghiem,
        }));
        setListMachine(newData);
      });
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy danh sách máy xét nghiệm"
      // );
    }
  };

  const getListMethod = async () => {
    try {
      const response = await analysisService.getListMethod().then((res) => {
        // console.log("res danh sach phương pháp xét nghiệm", res);
        const newData = res.data.map((item) => ({
          id: item.id,
          label: item.tenPhuongPhapXetNghiem,
          value: item.id,
        }));
        setListMethod(newData);
      });
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy danh sách phương pháp xét nghiệm"
      // );
    }
  };

  const handleOnShowResult = () => {
    setIsShowResult(true);
  };

  const handleCancel = () => {
    setIsShowModal(false);
    setIsShowResult(false);
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "ANALYSIS_DETAIL_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const rowSelectionList = {
    selectedRowKeysList,
    onChange: async (selectedRowKeysList, selectedRowsListss) => {
      setSelectedRowKeysList(selectedRowKeysList);
      // console.log(
      //   `selectedRowKeys:`, selectedRowKeysList,
      //   "selectedRows: ",
      //   selectedRowsListss
      // );
      const idArray = selectedRowsListss.map((item) => item.id);
      setSelectedRowsList(selectedRowsListss);
      setListIdPrint(idArray);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  return (
    <Spin spinning={loading}>
      <div className="detail-patient-analysis">
        <div className="container">
          <div className="header">Thông tin bệnh nhân</div>
          <div className="container-main">
            <Form form={form}>
              <PatientInfoCommon data={dataInfo} fields={field} />
            </Form>
          </div>
        </div>
        <div className="container step">
          <StepInfo ref={stepInfoRef} />
        </div>
        <TableSpecimens />
        <Space style={{ width: "100%" }} direction="vertical" size={"middle"}>
          <div className="container">
            <div className="header">Danh sách chỉ định xét nghiệm</div>
            <div className="container-main">
              <Row justify={"end"} gutter={[16, 16]}>
                <Space>
                  <Button
                    type="primary"
                    icon={<Icon.save />}
                    onClick={handleOnSave}
                  >
                    Lưu
                  </Button>
                  <Button
                    type="primary"
                    className="btn-sub"
                    onClick={handleOnShowResult}
                    // icon={<MicroscopeIconSVG />}
                  >
                    Nhập kết quả
                  </Button>
                  <Popover
                    trigger="click"
                    placement="bottomLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={defaultColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<ListIconSVG />}
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                </Space>
              </Row>
              <Form
                form={formData}
                initialValues={{ nguoiNhapKetQua: "Thạc sĩ Đỗ Trung Hiếu" }}
              >
                <CustomResizableTable
                  setShowColumns={setShowColumns}
                  className="table-list-analysis"
                  bordered
                  pagination={paginationConfig}
                  scroll={{ x: 2500 }}
                  dataSource={dataList}
                  columns={columns}
                  loading={loadingTable}
                  rowSelection={{
                    ...rowSelectionList,
                  }}
                />
              </Form>
            </div>
          </div>
        </Space>
        <ModalResults
          isShowModal={isShowModal}
          handleOk={showModal}
          handleCancel={handleCancel}
          detailRecord={detailRecord}
        />
        <ResultsAnalysis
          isShowModal={isShowResult}
          handleOk={showResult}
          handleCancel={handleCancel}
        />
        <ModalPrint
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          listId={listIdPrint}
        />
      </div>
      {/* Cảnh báo quá hạn ngày */}
      {/* <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom> */}
    </Spin>
  );
};

export default DetailInfo;
